import React from "react";
import Navbar from "../components/Navbar/Navbar";
import StrategyVid from "../components/StrategyVideos/StrategyVid";

const StrategyVideos = () => {
  return (
    <>
      <Navbar />
      <StrategyVid />
    </>
  );
};

export default StrategyVideos;
